import { useSitecoreContext } from 'hooks/useSitecoreContext';

const JSBeaconScript = () => {
  const { sitecoreContext } = useSitecoreContext();
  if (sitecoreContext.jsBeacon) {
    return <script type="text/javascript" async src={sitecoreContext.jsBeacon} />;
  }
  return null;
};

export default JSBeaconScript;
